// extracted by mini-css-extract-plugin
module.exports = {"listTable":"ListTable_listTable__mQifj","description":"ListTable_description__ZwgSg","value":"ListTable_value__TL0oN","mobileVerticalList":"ListTable_mobileVerticalList__UA8gi"};